export default "__VITE_ASSET__Bj8zfO6z__"